import { useApi } from '~/composables/useApi'

export const sendOtp = async () => {
  const { client } = useApi()
  // 認証コードはメールでのみ伝わるため、レスポンスには含まれない
  const response = await client.oneTimeTokens.$post()

  if (!response.ok) {
    throw new Error(`Failed to send OTP: ${response.status} ${response.statusText}`)
  }
}

type VerifyOtpResult =
  | { success: true }
  | { success: false; failedReason: 'notFound' | 'expired' | 'tooManyAttempts' | 'invalidCode' | 'unknownError' }

export const verifyOtp = async ({ otpCode }: { otpCode: string }): Promise<VerifyOtpResult> => {
  const { client } = useApi()
  // 検証の失敗は HTTP のエラーではなく、理由付きのボディで返る
  const response = await client.oneTimeTokens.verify.$post({ json: { otpCode } })

  if (!response.ok) {
    throw new Error(`Failed to verify OTP: ${response.status} ${response.statusText}`)
  }

  return await response.json()
}
